// TimeSlotSection.js - Updated with multiselect and improved props handling
import React from 'react';
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  useTheme
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

// Import the TimeSlotList component
import TimeSlotList from './timeSlotList';

// Styled components
const SectionHeading = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  color: theme.palette.text.primary
}));

const TimeSlotSection = ({
  loadingAvailability,
  timeSlots,
  handleTimeSlotSelect,
  room,
  selectedSlot,
  selectedDate,
  doBooking = () => { },
}) => {
  // Get theme from Material-UI
  const theme = useTheme();

  // Handle null or undefined timeSlots
  const validTimeSlots = Array.isArray(timeSlots) ? timeSlots : [];

  // Create a custom handler that formats the price information before passing to parent
  const handleSlotSelection = (room, slot) => {
    // Make sure price and price_vat are properly set
    // Pass null directly to parent if slot is null
    if (!slot) {
      handleTimeSlotSelect(room, null);
      return;
    }

    const formattedSlot = {
      ...slot,
      // If slot_price exists but price doesn't, use slot_price for price
      price: slot.price || slot.slot_price || 0,
      // If slot_price_vat exists but price_vat doesn't, use slot_price_vat for price_vat
      price_vat: slot.price_vat || slot.slot_price_vat || (slot.price || slot.slot_price || 0) * 1.2
    };

    // Call the parent's handler with the formatted slot
    handleTimeSlotSelect(room, formattedSlot);
  };

  return (
    <Paper elevation={0} variant="outlined" sx={{ p: 2, mb: 3, borderRadius: 1 }}>
      <SectionHeading variant="subtitle1">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          Select Time Slot
        </Box>
      </SectionHeading>

      {loadingAvailability ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TimeSlotList
          slots={validTimeSlots}
          onSelectSlot={handleSlotSelection}
          room={room}
          selectedSlot={selectedSlot}
          selectedDate={selectedDate}
          allowMultiSelect={true} // Enable multiple selection
          theme={theme}
          doBooking={doBooking}
        />
      )}
    </Paper>
  );
};

export default TimeSlotSection;